import pages from '@/enums/pages.json';

export const showPreviousPage = state => {
  state.page.pop();
};

export const showNumberGames = state => {
  state.page.push(pages.menu_numbers);
};

export const showMultiplierGames = state => {
  state.page.push(pages.menu_numbers_multipliers);
};

export const showFigureGames = state => {
  state.page.push(pages.menu_figures);
};

export const showLetterGames = state => {
  state.page.push(pages.menu_letters);
};

export const showColorGames = state => {
  state.page.push(pages.menu_colors);
};

export const showDeck = state => {
  state.page.push(pages.game);
};

export const showResult = state => {
  state.page.pop();
  state.page.push(pages.result);
};
